"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
const Input_1 = __importDefault(require("@mui/material/Input"));
const style_1 = __importDefault(require("./style"));
const SearchBox = ({ classes, onSearch, autoSearch = false, initialValue = '', collapsable = false, placeholder = 'Search available transactions', onHelp, showUnderline = false, autoFocus = false, }) => {
    var _a;
    const [isClearSearch, setIsClearSearch] = (0, react_1.useState)(false);
    const [searchState, setSearchState] = (0, react_1.useState)({
        smartSearchText: initialValue,
        activeSearch: false,
        searchOpen: Boolean(initialValue) || !collapsable,
    });
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isClearSearch) {
            return;
        }
        if (initialValue && !searchState.smartSearchText) {
            setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { smartSearchText: '' })));
        }
        if (initialValue && initialValue !== searchState.smartSearchText) {
            const newText = initialValue || '';
            setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { smartSearchText: newText, searchOpen: newText !== '', activeSearch: newText !== '' })));
        }
    }, [initialValue, searchState.smartSearchText, isClearSearch]);
    const resetFocus = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const clearSearch = () => {
        setIsClearSearch(true);
        setSearchState({
            smartSearchText: '',
            searchOpen: !collapsable,
            activeSearch: false,
        });
        if (onSearch) {
            onSearch('');
        }
        resetFocus();
        if (onHelp) {
            onHelp(false);
        }
    };
    const doSearch = (searchString = null) => {
        var _a;
        const filter = searchString || ((_a = searchState.smartSearchText) === null || _a === void 0 ? void 0 : _a.trim());
        if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
            if (onSearch) {
                onSearch(filter);
            }
            resetFocus();
            setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { activeSearch: true })));
        }
        else {
            clearSearch();
        }
    };
    const iconDoSearch = () => {
        if (searchState.searchOpen) {
            doSearch();
        }
        else {
            setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { searchOpen: true })));
            setTimeout(resetFocus, 100);
        }
    };
    const keyDown = (e) => {
        if (e.key === 'Enter') {
            doSearch();
            resetFocus();
        }
        if (e.key === 'Escape') {
            clearSearch();
            resetFocus();
            setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { searchOpen: !collapsable })));
        }
    };
    const handleChange = (e) => {
        var _a;
        const newValue = e.target.value;
        setSearchState((prevState) => (Object.assign(Object.assign({}, prevState), { smartSearchText: newValue })));
        if (autoSearch) {
            if (newValue.length <= 0) {
                clearSearch();
            }
            else if (newValue.length >= 2 || ((_a = searchState.smartSearchText) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                doSearch(newValue.trim());
            }
            else if (onSearch) {
                onSearch(null);
            }
        }
        else if (e.target.value.trim().length === 0 && searchState.activeSearch) {
            clearSearch();
        }
    };
    const showCancel = searchState.smartSearchText && ((_a = searchState.smartSearchText) === null || _a === void 0 ? void 0 : _a.length) > 0;
    let cancelAdorn = null;
    if (showCancel) {
        cancelAdorn =
            <div className={classes.iconHolder}>
        <Cancel_1.default aria-label="Cancel Search" id="cancel-search" className={(0, classnames_1.default)(classes.buttonFontSize, classes.cancelIcon, collapsable ? classes.searchIconButton : classes.searchIcon)} onClick={clearSearch} tabIndex={0}/>
      </div>;
    }
    else if (onHelp && searchState.searchOpen) {
        cancelAdorn =
            <div className={classes.iconHolder}>
        <HelpOutline_1.default aria-label="Cancel Search" id="help-search-adorn" className={(0, classnames_1.default)(classes.buttonFontSize, collapsable ? classes.searchIconButton : classes.searchIcon)} tabIndex={0} onClick={() => onHelp(true)}/>
      </div>;
    }
    return (<Input_1.default autoFocus={autoFocus} autoComplete="off" inputProps={{ 'aria-label': 'Search Transactions' }} label="Search Transactions" id="search" sharedcomponentid={'SEARCH_BOX'} inputRef={inputRef} classes={{
            root: (0, classnames_1.default)(classes.smartSearch, searchState.searchOpen || !collapsable ? 'open' : 'show', classes.root),
            input: (0, classnames_1.default)(classes.smartSearchInput, classes.input, searchState.searchOpen || !collapsable ? 'show' : 'hide'),
        }} margin="dense" placeholder={placeholder} value={searchState.smartSearchText} disableUnderline={!showUnderline} onKeyDown={keyDown} onChange={handleChange} startAdornment={<div className={classes.iconHolder}>
          <Search_1.default aria-label="Search" id="register-search-icon" className={collapsable ? classes.searchIconButton : classes.searchIcon} onClick={() => iconDoSearch()} tabIndex={0}/>
        </div>} endAdornment={cancelAdorn}/>);
};
exports.default = (0, mui_1.withStyles)(SearchBox, style_1.default);
